<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-for="(menuData, index) in $store.getters.menuArr">
                <li v-bind:key="index" :id="menuData.slug" :class="'menuCommon '+menuData.slug">
                    <template v-if="menuData.is_view_allow == 1">
                        <template v-if="menuData.sub_menu == '' || menuData.sub_menu == null">
                            <template v-if="menuData.url != null && menuData.url != '' && menuData.is_view_allow == 1">
                                <template v-if="menuData.menu_title.length >= 18">
                                    <a :href="menuData.url" target="_blank" v-b-tooltip.hover :title="menuData.menu_title">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                        </span>
                                        {{stringTrim(menuData.menu_title,18)}}
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="menuData.url" target="_blank">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                        </span>
                                        {{menuData.menu_title}}
                                    </a>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 18">
                                    <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span>{{stringTrim(menuData.menu_title,18)}}
                                    </router-link>
                                </template>
                                <template v-else>
                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span>{{menuData.menu_title}}
                                    </router-link>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.url != null && menuData.url != ''">
                                <template v-if="menuData.menu_title.length >= 18">
                                    <a v-b-tooltip.hover :title="menuData.menu_title" :href="menuData.url" target="_blank">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{stringTrim(menuData.menu_title,18)}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="menuData.url" target="_blank">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{menuData.menu_title}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </a>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 18">
                                    <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{stringTrim(menuData.menu_title,18)}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{menuData.menu_title}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </router-link>
                                </template>
                            </template>
                            <ul class="nav nav-list tree">
                                <template v-for="(subMenuData, index1) in menuData.sub_menu">
                                    <template v-if="subMenuData.is_view_allow == 1">
                                        <template v-if="subMenuData.url != null && subMenuData.url != ''">
                                            <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                                <template v-if="subMenuData.menu_title.length >= 30">
                                                    <a v-b-tooltip.hover :title="subMenuData.menu_title" :href="subMenuData.url" target="_blank">
                                                        {{stringTrim(subMenuData.menu_title,30)}}
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <a :href="subMenuData.url" target="_blank">
                                                        {{subMenuData.menu_title}}
                                                    </a>
                                                </template>
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                                <template v-if="subMenuData.menu_title.length >= 30">
                                                    <router-link v-b-tooltip.hover :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                        {{stringTrim(subMenuData.menu_title,30)}}
                                                    </router-link>
                                                </template>
                                                <template v-else>
                                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                        {{subMenuData.menu_title}}
                                                    </router-link>
                                                </template>
                                            </li>
                                        </template>
                                    </template>
                                </template>
                            </ul>
                        </template>
                    </template>
                </li>
                <!-- <li>
                    <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-marker fa-stack-1x "></i></span> Sales Programs <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                    <ul class="nav nav-list tree">
                        <li>Standard Operating Procedures</li>
                        <li>Marketing Materials</li>
                        <li>Warranty</li>
                        <li>Certification</li>
                        <li>Sales Meetings</li>
                        <li><a href="/colorchart">Color Chart</a></li>
                        <li><a href="#">Buttons</a></li>
                    </ul>
                </li> -->
            </template>
            <!-- <li>
                <label class="tree-toggle nav-header">
                    <span class="spm-nav-menu icon-procedures">    
                    </span>
                    Forms <i class="fa fa-angle-down" aria-hidden="true"></i>
                </label>
                <ul class="nav nav-list tree">
                    <template v-if="loginUserRoleId === 1 || loginUserRoleId === 2">
                        <li id="DayforceTimeRequest">
                            <router-link v-bind:to="{name: 'ListDayforaceTimeEditRequest'}">
                                Dayforce Time Edit Request
                            </router-link>
                        </li>
                        <li id="OfficeSuppliesForm">
                            <router-link v-bind:to="{name: 'ListOfficeSupplier'}">
                                Office Supplies Order
                            </router-link>
                        </li>
                    </template>
                    <template v-else>
                        <li id="DayforceTimeRequest">
                            <router-link v-bind:to="{name: 'AddUpdateDayforaceTimeEditRequest'}">
                                Dayforce Time Edit Request
                            </router-link>
                        </li>
                        <li id="OfficeSuppliesForm">
                            <router-link v-bind:to="{name: 'AddUpdateOfficeSupplier'}">
                                Office Supplies Order
                            </router-link>
                        </li>
                    </template>
                    <template v-if="permissionsArray.includes('access_vendor_request_form')">
                        <li id="ListVendor">
                            <router-link v-bind:to="{name: 'ListVendor'}">
                                Vendor
                            </router-link>
                        </li>
                    </template>
                    <template v-if="loginUsername == 9999999">
                        <li id="ListFormEmailManager">
                            <router-link v-bind:to="{name: 'ListFormEmailManager'}">
                                Form Email Manager
                            </router-link>
                        </li>
                    </template>
                    <li id="PARRequest">
                        <router-link v-bind:to="{name: 'ListPARRequest'}">
                            PAR Request
                        </router-link>
                    </li>
                </ul>
            </li> -->
        </ul>
    </div>
<!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../../http-common.js';
    import EventBus from '.././event-bus';
    var self;

    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: 'Center',
        mixins: [commonMixins],
        data() {
            return {
                menuArr: [],
                loginUserRoleId: 1,
                loginUsername: 9999999,
                permissionsArray: ['access_vendor_request_form'],
            }
        },
        beforeMount: function () {
        },
        mounted: function () {
            self = this;
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function (e) {
                //console.log("here");
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
                self.loginUsername = userJson['username'];
                self.$store.dispatch('loadMenu');
            }
        },
        methods: {
        }
    };
    EventBus.$on('reload-menu', function (menuArr) {
        //console.log('Event Called');
        if (typeof (self) != 'undefined') {
            self.$nextTick(() => {
                self.firstLoadMenu();
            });
        }
    });
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            if(permissionArray && permissionArray.length > 0) {
                for (var i = 0; i < permissionArray.length; i++) {
                    self.permissionsArray.push(permissionArray[i].name);
                }
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue